module.exports = __webpack_public_path__ + "media/long_gb.1a17be00.mp3";